import React, { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';

export default function SubproviderUpsert(param: any) {

    let [Subprovider, setSubprovider] = useState<any>(param?.editDataDawer ?? []);

    const closeDrawer = () => { param.closeDrawer() }

    const onReset = () => {
        console.log(param?.editDataDawer)
        if (param?.editDataDawer) {
            Subprovider = param?.editDataDawer
            setSubprovider(Subprovider)
        }
    }

    const onSave = () => {
        /*systemFormatsList.saveStatusAccount(Subprovider).then((respond: any) => {
            CommonUtilities.showToastDawer('Account Status Saved', 'Success')
        })*/
    }


    return (<>

        <Drawer open={param.openUpsertUX} direction='right' className='react-drawer allowHscroll ' size={800}>

            <div className="pull-right ws-5 box full-height-vh " >

                <div className="ws-12 bg-blue ">
                    <h1 className="pull-left text-center mt mll">Add Subprovider</h1>
                    <i className="icon-close pull-right pLarge" onClick={closeDrawer}></i>
                </div>

                <div className="box-content">

                    <div className="ws-12">
                        <div className="ws-6">

                            <div className="form-format">
                                <label className="control-label" title="fsaAccountCode">Account Code*</label>
                                <div className="label-entries">
                                    <input type="text" placeholder="Enter Account Code" value={Subprovider.fsaAccountCode ?? ""} required id="fsaAccountCode" disabled />
                                </div>
                            </div>

                            <div className="form-format">
                                <label className="control-label" title="fsapSubProvder">Sub Provider</label>
                                <div className="label-entries">
                                    <input type="text" placeholder="Enter Sub Provider" value={Subprovider.fsapSubProvder ?? ""} data-ng-disabled="accountsEdit" id="fsapSubProvder" name="fsapSubProvder" disabled />
                                </div>
                            </div>

                        </div>

                        <div className="ws-6">
                            <div className="form-format">
                                <label className="control-label" title="showAccountCode">Account Code Display*</label>
                                <div className="label-entries">
                                    <input type="text" placeholder="Enter Account Code Display" value={Subprovider.showAccountCode ?? ""} required id="showAccountCode" name="showAccountCode" />
                                </div>
                            </div>

                            <div className="form-format">
                                <label className="control-label" title="showSubProvder">Sub Provider Display</label>
                                <div className="label-entries">
                                    <select ng-model="showSubProvder" ng-options="dsp.name as dsp.name for dsp in clientDSPList" >
                                        <option value="" >Choose a show Sub Provder</option>
                                    </select>
                                </div>
                            </div>

                            <div className="form-format">
                                <label className="control-label" title="showSingleAccSub">Single Acc Sub Display</label>
                                <div className="label-entries">
                                    <input type="text" placeholder="Enter Single Acc Sub Display" value={Subprovider.showSingleAccSub ?? ""} id="showSingleAccSub" name="showSingleAccSub" />
                                </div>
                            </div>

                        </div>

                    </div>
                </div>

                {/* Footer */}
                <div className="box-footer ws-12 pull-right">
                    <button type="button" className="icon-btn delete pull-right" onClick={closeDrawer}>x Close</button>
                    <button type="button" className="icon-btn delete pull-right" onClick={onReset}>↻ Reset</button>
                    <button type="button" className="icon-btn edit pull-right" onClick={onSave}>✔ Save </button>
                </div>
            </div>

        </Drawer>
    </>)
}